import { Navigate, useLocation } from 'react-router'

import { ROUTES } from '@/router'
import { TLoginType } from '@/typings'
import { ID_TOKEN, LOGIN_TYPE } from '@/utils/constant/storage'

interface Props {
  children: React.ReactElement
}
const PRIVATE_PATHS = [
  '/sign-up',
  '/sign-in',
  '/sign-out',
  '/forgot-password',
  '/verify-otp',
  '/reset-password',
  '/password-changed',
  '/loans',
  '/members',
  '/roles',
  '/billings',
  '/settings',
  '/trash',
  '/libraries',
  '/callback',
  '/wishlist',
  '/books',
  '/shelves',
  '/shelf-groups',
  '/items',
  '/tags',
  '/organization',
  '/account',
  '/notification',
  '/switch-tenant',
  '/acceptinvitation',
  '/discover',
  '/barcode_generator',
  '/registrations',
  '/statistics',
  '/member-check-in',
  '/generate-book-cover',
]

const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const token = localStorage.getItem(ID_TOKEN)
  const loginType = localStorage.getItem(LOGIN_TYPE)
  const location = useLocation()

  const PUBLIC_PATHS = [ROUTES.SHARE, `${ROUTES.LI}/`]
  const isPublicLink = PUBLIC_PATHS.some((path) => location.pathname.includes(path))
  const isPrivatePath = PRIVATE_PATHS.some(
    (path) => location.pathname === path || location.pathname.startsWith(`${path}/`),
  )

  if (isPublicLink || !isPrivatePath) {
    return children
  }

  if (!token && loginType !== TLoginType.THIRD_PARTY) {
    return <Navigate to={ROUTES.SIGN_IN} />
  }

  return children
}

export default ProtectedRoute
